module.exports = __webpack_public_path__ + "img/ag-blue.8741854a.svg";